module.exports = __webpack_public_path__ + "img/获得授权.36f77273.svg";